 angular
   .module('vppApp')
   .service('redirectIntercept', redirectIntercept);
 redirectIntercept.$inject = ['$location', '$rootScope'];

 function redirectIntercept($location, $rootScope) {
   var thisUrl = $location.path();
   var pathSections = thisUrl.split('/');
   if (pathSections[1] === 'set-up-event') {
     $location.path('/');
   }
   return;
 }
